export default "__VITE_ASSET__DvksUgqQ__"